import { invariant } from '@mimir/common/util/invariant';

export type UndoFn = () => void;

/**
 * This helper class provides a way to group multiple
 * undoable operations into one undoable action.
 */
export class UndoHelper {

  private undone = false;
  private readonly functions: UndoFn[] = [];

  add(fn: UndoFn): void {
    invariant(!this.undone, 'Cannot add after undo() has been invoked');
    this.functions.push(fn);
  }

  undo() {
    invariant(!this.undone, 'Cannot undo multiple times');
    this.functions.reverse();
    for (const fn of this.functions) {
      fn();
    }
    this.undone = true;
  }
}
